import fetchModels from "../../mixin/store/api/fetchModels";
import changeOrPushModel from "../../mixin/store/api/changeOrPushModel";
import deleteModel from "@/mixin/store/api/deleteModel";
import axios from "@/plugins/axios";
import fetchModel from "@/mixin/store/api/fetchModel";
import pushModel from "../../mixin/store/api/pushModel";

export default {
    actions: {
        fetchProducts(context, page = 1) {
            return fetchModels(context, 'products?order[id]=desc', page, 'updateProducts');
        },
        fetchProductsSearch(context, companyId) {
            if (context.state.purchasePageProducts.isNeedFetch) {
                return axios.get(`products?pagination=false&company.id=${companyId}`)
                    .then((response) => {
                        console.log(response)
                        let data = {
                            models: response.data['hydra:member'],
                            totalItems: response.data['hydra:totalItems']
                        }
                        context.commit('updatePurchasePageProducts', data)

                    })
                    .catch((err) => {
                        console.log(err)
                    })

            }
        },
        fetchSelfMadeProducts(context, page = null) {
            return fetchModels(context, 'products/self-made', page, 'updateSelfMadeProducts');
        },
        fetchProduct(context, id) {
            return fetchModel(context, 'products', id, 'updateProduct');
        },
        fetchDeletedProducts(context, page) {
            return fetchModels(context, 'products/deleted', page, 'updateProducts');
        },
        searchDeletedProduct(context, searchItem) {
            let url = "products/deleted?page=" + searchItem.page;

            if (searchItem.productName) {
                url = url + '&name=' + searchItem.productName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateProducts', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        pushProduct(context, data) {
            data.sellingPriceCurrency = context.getters.getCurrency(data.sellingPriceCurrencyId)['@id']
            return changeOrPushModel(context, 'products', data)
        },
        pushProducts(context, data) {
            return changeOrPushModel(context, 'products/add', data)
        },
        pushAdditionalUnitOfMeasure(context, data) {
            return changeOrPushModel(context, 'additional_unit_of_measures', data)
        },
        deleteProduct(context, id) {
            return deleteModel(context, 'products', id);
        },
        searchProduct(context, searchItem) {
            let url
            if (searchItem.isPurchaseProductPage) {
                url = "products?pagination=false"
            } else {
                url = "products?page=" + searchItem.page + `&company.id=${searchItem.companyId}`;
            }

            if (searchItem.product) {
                url = url + '&name=' + searchItem.product
            }

            if (searchItem.minSellingPrice) {
                url = url + '&sellingPrice[gte]=' + searchItem.minSellingPrice
            }

            if (searchItem.maxSellingPrice) {
                url = url + '&sellingPrice[lte]=' + searchItem.maxSellingPrice
            }

            if (searchItem.category) {
                url = url + '&categories=' + searchItem.category
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    if (searchItem.isPurchaseProductPage) {
                        context.commit('updatePurchasePageProducts', data)
                    } else {
                        context.commit('updateProducts', data)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        pushProductRestore(context, selectedProductIds) {
            return pushModel(context, 'products/restore', {ids: selectedProductIds})
        }
    },
    mutations: {
        updateProducts(state, data) {
            state.products = data
            state.products.isNeedFetch = false
        },
        updatePurchasePageProducts(state, data) {
            state.purchasePageProducts = data
            state.purchasePageProducts.isNeedFetch = false
        },
        updateSelfMadeProducts(state, data) {
            state.selfMadeProducts = data
        },
        updateProduct(state, data) {
            state.product = data
        },
    },
    state: {
        product: {
            id: null,
            name: '',
            barCode: null,
            sellingPrice: '',
            unitOfMeasure: '',
            sellingPriceCurrency: {
                id: null
            },
            company: '',
            categories: [],
            additionalUnitOfMeasures: []
        },
        products: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        purchasePageProducts: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        selfMadeProducts: {
            models: [],
            totalItems: 0
        },
    },
    getters: {
        getProduct(state) {
            return state.product
        },
        findProduct: (state, getters) => (id) => {
            return getters.getProducts.find(model => model.id === id)
        },
        getDeletedProducts(state) {
            return state.products.models
        },
        getDeletedProductsTotalCount(state) {
            return state.products.totalItems
        },
        getProducts(state) {
            return state.products.models
        },
        getPurchasePageProducts(state) {
            return state.purchasePageProducts.models
        },
        getSelfMadeProducts(state) {
            return state.selfMadeProducts.models
        },
        getProductsTotalCount(state) {
            return state.products.totalItems
        },
        getPurchasePageProductsTotalCount(state) {
            return state.purchasePageProducts.totalItems
        }
    },
}
